import type { CustomCellRendererProps } from "ag-grid-react";
import React from "react";
import { useDispatch } from "react-redux";
import { addMemberToRole } from "src/actions/roleManagement";
import type { UID } from "src/types";
import { RoleContainer } from "./styles";

interface RoleCellRendererProps extends CustomCellRendererProps {
  data: { uid: UID };
  roleTitles: Array<{ id: number; title: string; label: string }>;
}

export const RoleCellRenderer = ({
  data,
  value,
  roleTitles,
}: RoleCellRendererProps): React.ReactElement => {
  const dispatch = useDispatch();

  const handleRoleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    e.preventDefault();
    dispatch(addMemberToRole(parseInt(e.target.value, 10), [data.uid]));
  };

  return (
    <RoleContainer>
      <select value={value} onChange={handleRoleChange}>
        {roleTitles.map((role) => (
          <option key={role.id} value={role.id}>
            {role.label}
          </option>
        ))}
      </select>
    </RoleContainer>
  );
};
